<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="cbp-spmenu-push">
    <!-- banner -->
    <div class="banner">
      <div class="container">
        <div class="banner-info">
          <span>Quality & Safety</span>
        </div>
      </div>
    </div>
    <!-- banner-bottom -->
    <section>
      <!-- 品质管理 -->
      <section id="pzgl">
        <div class="container gradient-background">
          <div class="row">
            <div class="col-lg-12 rzTop">
              <h1><span>Quality Management System</span></h1>
              <p class="rzp">
                Far East Group's quality policy is rooted in an uncompromising
                spirit. We are committed to meeting customer requirements and
                adhering to technical specifications. Our approach involves
                continuous product improvement and striving for excellence. We
                work closely with the supervision team assigned by our customers
                to ensure compliance with standards set by the relevant
                authorities, aiming not only to meet but to exceed customer
                expectations.<br /><br />
                Far East Group's quality management emphasizes a
                customer-oriented approach, with leadership prioritizing this
                commitment to achieve enhanced performance through the active
                participation of all employees. At the operational level, Far
                East is dedicated to creating a conducive working environment
                and promoting the long-term implementation of the 5S management
                system to optimize internal resource utilization. The company
                collaborates closely with quality inspection personnel to
                conduct thorough on-site corrections and provide guidance,
                ensuring that any issues are identified and addressed promptly.
                Far East Group maintains strict process management and quality
                control standards, overseeing every detail of the manufacturing
                process, from raw materials to finished products. We work in
                partnership with our customers to ensure that every component
                manufactured by Far East Group meets the highest standards of
                perfection.
              </p>
              <div class="container-fluid">
                <div
                  class="col-lg-3 col-xs-6"
                  v-for="(item, index) in pzglList"
                  :key="index"
                >
                  <div class="pzglImg">
                    <img
                      :src="item.image"
                      alt=""
                      style="width: 100%; height: 100%"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 產品質量 -->

          <div class="row" id="cpzl">
            <div class="col-lg-12 cpTop">
              <h1><span>Product Quality</span></h1>
            </div>
          </div>
          <div class="container-fluid">
            <carousel-3d
              :controlsVisible="true"
              :width="cWidth"
              :height="cHeight"
              :display="cNum"
              :space="280"
            >
              <slide
                v-lazy-container="{ selector: 'img' }"
                :index="index"
                v-for="(item, index) in cpzlList"
                :key="index"
              >
                <div class="col-lg-12 col-xs-12">
                  <h2 class="slideh2">{{ item.title }}</h2>
                  <div class="col-lg-6">
                    <img :data-src="item.img1" class="slideImg" alt="" />
                    <p class="slideP">{{ item.txt1 }}</p>
                  </div>
                  <div class="col-lg-6">
                    <img :data-src="item.img2" class="slideImg" alt="" />
                    <p class="slideP">{{ item.txt2 }}</p>
                  </div>
                </div>
                <p
                  class="slideP"
                  style="
                    position: absolute;
                    bottom: 0;
                    left: 50%;
                    transform: translate(-50%, 0);
                  "
                >
                  Page:{{ index + 1 }}/23
                </p>
              </slide>
            </carousel-3d>
          </div>

          <!-- 產品包裝 -->
          <div class="row" id="cpbz">
            <div class="col-lg-12 rzTop">
              <h1><span>Product Packaging</span></h1>
              <p class="rzp">
                To ensure that every component received by the customer is in
                perfect condition, Far East Group packages its products based on
                the distance and method of transportation, as well as the
                customer's requirements. Our excellent packaging safeguards the
                components during challenging transport conditions, allowing us
                to ship our products to any location. We have successfully
                delivered products to over 30 countries, including the United
                States, Japan, various countries in Europe, Australia, South
                Korea, Thailand, South Africa, Haiti, Angola, and more.
              </p>
              <div class="container-fluid">
                <div
                  class="col-lg-4 col-xs-6"
                  v-for="(item, index) in cpbzList"
                  :key="index"
                >
                  <div class="cpbzImg">
                    <img
                      :src="item.image"
                      alt=""
                      style="width: 100%; height: 100%"
                    />
                  </div>
                  <div class="cpp">
                    <p>{{ item.text }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 安全政策 -->
          <div class="row" id="aqzc">
            <div class="col-lg-12 rzTop">
              <h1><span>Occupational Safety Policy</span></h1>
              <p class="rzp">
                Far East Group is committed to the goal of “Zero Workplace
                Accidents,” operating in strict compliance with occupational
                safety regulations and international standards. We hold multiple
                prestigious certifications, including AISC, AWS, CWB W47.1/CSA
                A660-10, EN 1090, ISO 3834, ISO 45001, ISO 9001, ISO 14001,
                China Class 1 Steel Structure Qualification, and Japan JSA. Our
                safety policies require all on-site personnel to correctly wear
                PPE (Personal Protective Equipment), while we provide structured
                safety training, conduct systematic site audits, and implement
                automated inspections. With rigorous safety management and
                consistent delivery of high-quality work, we have been
                repeatedly recognized by global leading EPCs with “Safe Working
                Hours Awards” and “Outstanding Steel Structure Supplier” honors,
                reinforcing our reputation as a trusted partner in global steel
                structure projects.
              </p>
            </div>
            <div class="col-lg-12" style="text-align: center">
              <img src="@/components/img/pzyaq/aqzc.jpg" alt="" class="aqImg" />
            </div>
          </div>
        </div>
      </section>

      <div class="mailbg">
        <to-mail buttonText="REQUEST A QUOTE"></to-mail>
      </div>
      <!-- 小滾輪 -->
      <div id="ss_menu">
        <div>
          <i><a @click="forId('pzgl')">Management</a></i>
        </div>
        <div>
          <i><a @click="forId('cpzl')">Quality</a></i>
        </div>
        <div>
          <i><a @click="forId('cpbz')">Packaging</a></i>
        </div>
        <div>
          <i
            ><a @click="forId('aqzc')">Safety<br />Policy</a></i
          >
        </div>
        <div class="menu">
          <div class="share" id="ss_toggle" data-rot="180">
            <div class="circle"></div>
            <div class="bar"></div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pzglList: [
        {
          image: require('@/components/img/pzyaq/pzgl1.jpg'),
        },
        {
          image: require('@/components/img/pzyaq/pzgl2.jpg'),
        },
        {
          image: require('@/components/img/pzyaq/pzgl3.jpg'),
        },
        {
          image: require('@/components/img/pzyaq/pzgl4.jpg'),
        },
      ],
      cpzlList: [
        {
          title: 'Raw Material Management',
          img1: require('@/components/img/pzyaq/cpdb1.jpg'),
          txt1: 'Common problems: Raw materials are placed randomly, and different materials are not distinguished. Workers can easily take and use them randomly.',
          img2: require('@/components/img/pzyaq/cpdb1-1.jpg'),
          txt2: 'Hua Yin: There is a suitable storage location and the materials and methods are well-organized',
        },
        {
          title: 'Color And Barcode Management',
          img1: require('@/components/img/pzyaq/cpdb2.jpg'),
          txt1: 'Common problems: Materials are not labeled, making it easy to make mistakes during production.',
          img2: require('@/components/img/pzyaq/cpdb2-1.jpg'),
          txt2: 'Hua Yin: Different steel grades are distinguished by color brushing',
        },
        {
          title: 'Raw Material Supplier',
          img1: require('@/components/img/pzyaq/cpdb3.jpg'),
          txt1: 'Common question: Choosing a steel mill without any identification is considered a "three-no" product.',
          img2: require('@/components/img/pzyaq/cpdb3-1.jpg'),
          txt2: 'Hua Yin: Choose well-known domestic steel mills such as Shougang and Masteel.',
        },
        {
          title: 'Steel Plate Cutting Quality',
          img1: require('@/components/img/pzyaq/cpdb4.jpg'),
          txt1: 'Common problems: The cutting surface is uneven with sawtooth defects, and the appearance quality is very poor.',
          img2: require('@/components/img/pzyaq/cpdb4-1.jpg'),
          txt2: 'Hua Yin: CNC cutting, with good surface quality of the cut.',
        },
        {
          title: 'Free Edge Chamfering And Polishing',
          img1: require('@/components/img/pzyaq/cpdb5.jpg'),
          txt1: 'Common issues: The free part has not been chamfered and polished, and there are burrs that have not been removed.',
          img2: require('@/components/img/pzyaq/cpdb5-1.jpg'),
          txt2: 'Hua Yin: All cut surfaces and free edges are chamfered and polished.',
        },
        {
          title: 'Lead Plate Arc',
          img1: require('@/components/img/pzyaq/cpdb6.jpg'),
          txt1: 'Common problem: No arc starting plate is installed.',
          img2: require('@/components/img/pzyaq/cpdb6-1.jpg'),
          txt2: 'Hua Yin: Install arc starting plates for BH submerged arc welding seams.',
        },
        {
          title: 'Chamfer',
          img1: require('@/components/img/pzyaq/cpdb7.jpg'),
          txt1: 'Common problem: There are burrs in the bolt holes, which affect the adhesion of the paint.',
          img2: require('@/components/img/pzyaq/cpdb7-1.jpg'),
          txt2: 'Hua Yin: All the bolt holes have been chamfered and ground',
        },
        {
          title: 'Chamfer Through The Weld Hole',
          img1: require('@/components/img/pzyaq/cpdb8.jpg'),
          txt1: 'Common problems: No weld holes are drilled, the formation at the intersection of the three welds is very poor, and there are arc pit defects.',
          img2: require('@/components/img/pzyaq/cpdb8-1.jpg'),
          txt2: 'Hua Yin: There are perforated weld holes at the intersections of the main welds to prevent stress concentration, and the fillet welds are qualified.',
        },
        {
          title: 'Positioning Welding',
          img1: require('@/components/img/pzyaq/cpdb9.jpg'),
          txt1: 'Common problem: Spot welding is carried out randomly without any process requirements.',
          img2: require('@/components/img/pzyaq/cpdb9-1.jpg'),
          txt2: 'Hua Yin: Spot welding fixation is required as per the process requirements. The length should be 100 to 150, and the spacing 300 to 400.',
        },
        {
          title: 'Submerged Arc Welding',
          img1: require('@/components/img/pzyaq/cpdb10.jpg'),
          txt1: 'Common problems: The size of the weld corner is uneven, and there is no smooth transition and effective fusion between the weld bead and the base material',
          img2: require('@/components/img/pzyaq/cpdb10-1.jpg'),
          txt2: 'Hua Yin: The weld seams have a smooth transition and the appearance is very beautiful. There are no weld seam defects at all.',
        },
        {
          title: 'Internal Section Of The Weld Seam',
          img1: require('@/components/img/pzyaq/cpdb11.jpg'),
          txt1: 'Common problem: After the internal section of the weld seam was exposed, it did not fuse.',
          img2: require('@/components/img/pzyaq/cpdb11-1.jpg'),
          txt2: 'Hua Yin: After the internal section of the weld seam was revealed, it was completely fused',
        },
        {
          title: 'Steel Structure Correction',
          img1: require('@/components/img/pzyaq/cpdb12.jpg'),
          txt1: 'Common problem: Distortion and deformation after welding are not corrected.',
          img2: require('@/components/img/pzyaq/cpdb12-1.jpg'),
          txt2: 'Hua Yin: After correction, it meets the requirements of the norms.',
        },
        {
          title: 'Cutting',
          img1: require('@/components/img/pzyaq/cpdb13.jpg'),
          txt1: 'Common problems: Manual cutting is not straight, the cut lines are deep, and there are residues that have not been removed.',
          img2: require('@/components/img/pzyaq/cpdb13-1.jpg'),
          txt2: 'Hua Yin: The machine cuts straight and smooth without any defects.',
        },
        {
          title: 'Fabrication Of Platform Beams',
          img1: require('@/components/img/pzyaq/cpdb14.jpg'),
          txt1: 'Common problem: Manually cut without R corners.',
          img2: require('@/components/img/pzyaq/cpdb14-1.jpg'),
          txt2: 'Hua Yin: The exposed R corner transitions smoothly.',
        },
        {
          title: 'Submerged Arc Automatic Welding (SAW)',
          img1: require('@/components/img/pzyaq/cpdb15.jpg'),
          txt1: 'Common problem: The quality of welding produced by domestic submerged arc welding machines is very poor.',
          img2: require('@/components/img/pzyaq/cpdb15-1.jpg'),
          txt2: 'Hua Yin: The imported submerged arc welding machine is very advanced, and the quality of the welded structures is excellent',
        },
        {
          title: 'Cutting Of The Notch Surface',
          img1: require('@/components/img/pzyaq/cpdb16.jpg'),
          txt1: 'Common problems: The cutting surface is not straight and has notches.',
          img2: require('@/components/img/pzyaq/cpdb16-1.jpg'),
          txt2: 'Hua Yin: The cutting surface is flat and smooth.',
        },
        {
          title: 'Patchwork Technique',
          img1: require('@/components/img/pzyaq/cpdb17.jpg'),
          txt1: 'Common question: There are no requirements for the assembly process.',
          img2: require('@/components/img/pzyaq/cpdb17-1.jpg'),
          txt2: 'Hua Yin: Make bevels according to the manufacturing process, polish and assemble',
        },
        {
          title: 'SMAW Weld Seam',
          img1: require('@/components/img/pzyaq/cpdb18.jpg'),
          txt1: 'Common problems: Rough weld seams and poor shaping.',
          img2: require('@/components/img/pzyaq/cpdb18-1.jpg'),
          txt2: 'Hua Yin: The weld seams are smooth and neat.',
        },
        {
          title: 'Multi-pass Welding',
          img1: require('@/components/img/pzyaq/cpdb19.jpg'),
          txt1: 'Common problem: The weld beads are not fused with each other.',
          img2: require('@/components/img/pzyaq/cpdb19-1.jpg'),
          txt2: 'Hua Yin: The weld seams are smooth and neat.',
        },
        {
          title: 'GMAW Welding',
          img1: require('@/components/img/pzyaq/cpdb20.jpg'),
          txt1: 'Common problems: Rough weld formation and defective appearance.',
          img2: require('@/components/img/pzyaq/cpdb20-1.jpg'),
          txt2: 'Hua Yin: The weld seam is formed beautifully and smoothly with a smooth transition.',
        },
        {
          title: 'Shot Blasting For Rust Removal',
          img1: require('@/components/img/pzyaq/cpdb21.jpg'),
          txt1: 'Common problem: The rust removal grade is not thorough.',
          img2: require('@/components/img/pzyaq/cpdb21-1.jpg'),
          txt2: 'Hua Yin: The rust removal grade reaches Sa2 ½.',
        },
        {
          title: 'Spray Painting Quality',
          img1: require('@/components/img/pzyaq/cpdb22.jpg'),
          txt1: 'Common problems: Multiple scratches on the paint and uneven paint thickness.',
          img2: require('@/components/img/pzyaq/cpdb22-1.jpg'),
          txt2: 'Hua Yin: The paint coating is uniform and there are no defects in the appearance.',
        },
        {
          title: 'Friction Surface Sticker Protection',
          img1: require('@/components/img/pzyaq/cpdb23.jpg'),
          txt1: 'Common problem: The friction surface is not pasted or painted.',
          img2: require('@/components/img/pzyaq/cpdb23-1.jpg'),
          txt2: 'Hua Yin: The friction surface should be affixed with stickers as per the specifications.',
        },
      ],
      cpbzList: [
        {
          image: require('@/components/img/pzyaq/cpbz1.jpg'),
          text: 'Cargo ship transportation',
        },
        {
          image: require('@/components/img/pzyaq/cpbz2.jpg'),
          text: 'Large item packaging',
        },
        {
          image: require('@/components/img/pzyaq/cpbz3.jpg'),
          text: 'Container packing',
        },
        {
          image: require('@/components/img/pzyaq/cpbz4.jpg'),
          text: 'Small item packaging',
        },
        {
          image: require('@/components/img/pzyaq/cpbz5.jpg'),
          text: 'Module packaging',
        },
        {
          image: require('@/components/img/pzyaq/cpbz6.jpg'),
          text: 'Special packaging',
        },
      ],
    }
  },
  methods: {
    // 調用全局方法，滾動指定id
    forId(tId) {
      console.log(tId)
      this.$store.dispatch('toID', tId)
    },
    changeHeight() {
      if (document.body.clientWidth >= 2000) {
        this.cWidth = 1400
        this.cHeight = 800
        this.cNum = 5
      } else if (
        document.body.clientWidth > 1400 &&
        document.body.clientWidth < 2000
      ) {
        this.cWidth = 1000
        this.cHeight = 650
        this.cNum = 3
      } else if (
        document.body.clientWidth >= 768 &&
        document.body.clientWidth <= 1400
      ) {
        this.cWidth = 600
        this.cHeight = 500
        this.cNum = 3
      } else if (document.body.clientWidth < 768) {
        this.cWidth = 1000
        this.cHeight = 1450
        this.cNum = 3
      }
    },
  },
  mounted() {
    // 獲取高度
    window.onresize = () => {
      this.changeHeight()
    }
  },
  created() {
    this.changeHeight()
  },
  updated() {
    if (this.scrollToElement) {
      this.scrollToElement()
      this.scrollToElement = null
    }
  },
}
</script>

<style scoped>
/* 榮譽圖片註釋設置 */
.cbp-spmenu-push {
  overflow-x: hidden;
  position: relative;
  left: 0;
  -webkit-transition: all 0.3s ease;
  -moz-transition: all 0.3s ease;
  transition: all 0.3s ease;
}
.cbp-spmenu-push .banner {
  background: url(@/components/img/pzyaq/1.jpg) 0px 0px no-repeat;
  background-size: cover;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  -ms-background-size: cover;
  height: 500px;
  position: relative;
  width: 100%;
  background-size: 100% 100%;
}

/*-- banner-info --*/
.banner-info {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}
.banner-info span {
  font-size: 50px;
  color: #fff;
  padding: 0 10px;
  margin: 0 auto;
  line-height: normal;
  background: rgba(0, 0, 0, 0.6);
  font-weight: 700;
}
/***** Lexi *****/
/* 小滾輪 */
@-webkit-keyframes badbounce {
  0%,
  100% {
    -webkit-transform: translateY(0px);
  }
  10% {
    -webkit-transform: translateY(6px);
  }
  30% {
    -webkit-transform: translateY(-4px);
  }
  70% {
    -webkit-transform: translateY(3px);
  }
  90% {
    -webkit-transform: translateY(-2px);
  }
}

@-moz-keyframes badbounce {
  0%,
  100% {
    -moz-transform: translateY(0px);
  }
  10% {
    -moz-transform: translateY(6px);
  }
  30% {
    -moz-transform: translateY(-4px);
  }
  70% {
    -moz-transform: translateY(3px);
  }
  90% {
    -moz-transform: translateY(-2px);
  }
}

@keyframes badbounce {
  0%,
  100% {
    -webkit-transform: translateY(0px);
    -moz-transform: translateY(0px);
    -ms-transform: translateY(0px);
    -o-transform: translateY(0px);
    transform: translateY(0px);
  }
  10% {
    -webkit-transform: translateY(6px);
    -moz-transform: translateY(6px);
    -ms-transform: translateY(6px);
    -o-transform: translateY(6px);
    transform: translateY(6px);
  }
  30% {
    -webkit-transform: translateY(-4px);
    -moz-transform: translateY(-4px);
    -ms-transform: translateY(-4px);
    -o-transform: translateY(-4px);
    transform: translateY(-4px);
  }
  70% {
    -webkit-transform: translateY(3px);
    -moz-transform: translateY(3px);
    -ms-transform: translateY(3px);
    -o-transform: translateY(3px);
    transform: translateY(3px);
  }
  90% {
    -webkit-transform: translateY(-2px);
    -moz-transform: translateY(-2px);
    -ms-transform: translateY(-2px);
    -o-transform: translateY(-2px);
    transform: translateY(-2px);
  }
}

.ss_animate {
  -webkit-animation: badbounce 1s linear;
  -moz-animation: badbounce 1s linear;
  animation: badbounce 1s linear;
}

#ss_menu {
  z-index: 999;
  bottom: 10px;
  width: 60px;
  height: 60px;
  color: #fff;
  position: fixed;
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
  right: 15px;
  -webkit-transform: rotate(180deg);
  -moz-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  -o-transform: rotate(180deg);
  transform: rotate(180deg);
}

#ss_menu > .menu {
  padding: 32px 0 !important;
  position: absolute;
  border-radius: 50%;
  width: 60px;
  height: 60px !important;
  text-align: center;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.23), 0 3px 10px rgba(0, 0, 0, 0.16);
  color: #fff;
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
}

#ss_menu > .menu .share {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0px;
  top: 0px;
  -webkit-transform: rotate(180deg);
  -moz-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  -o-transform: rotate(180deg);
  transform: rotate(180deg);
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
}

#ss_menu > .menu .share .circle {
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
  position: absolute;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #fff;
  top: 50%;
  margin-top: -6px;
  left: 12px;
  opacity: 1;
}

#ss_menu > .menu .share .circle:after,
#ss_menu > .menu .share .circle:before {
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
  content: '';
  opacity: 1;
  display: block;
  position: absolute;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #fff;
}

#ss_menu > .menu .share .circle:after {
  left: 20.78461px;
  top: 12px;
}

#ss_menu > .menu .share .circle:before {
  left: 20.78461px;
  top: -12px;
}

#ss_menu > .menu .share .bar {
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
  width: 24px;
  height: 3px;
  background: #fff;
  position: absolute;
  top: 50%;
  margin-top: -1.5px;
  left: 18px;
  -webkit-transform-origin: 0% 50%;
  -moz-transform-origin: 0% 50%;
  -ms-transform-origin: 0% 50%;
  -o-transform-origin: 0% 50%;
  transform-origin: 0% 50%;
  -webkit-transform: rotate(30deg);
  -moz-transform: rotate(30deg);
  -ms-transform: rotate(30deg);
  -o-transform: rotate(30deg);
  transform: rotate(30deg);
}

#ss_menu > .menu .share .bar:before {
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
  content: '';
  width: 24px;
  height: 3px;
  background: #fff;
  position: absolute;
  left: 0px;
  -webkit-transform-origin: 0% 50%;
  -moz-transform-origin: 0% 50%;
  -ms-transform-origin: 0% 50%;
  -o-transform-origin: 0% 50%;
  transform-origin: 0% 50%;
  -webkit-transform: rotate(-60deg);
  -moz-transform: rotate(-60deg);
  -ms-transform: rotate(-60deg);
  -o-transform: rotate(-60deg);
  transform: rotate(-60deg);
}

#ss_menu > .menu .share.close .circle {
  opacity: 0;
}

#ss_menu > .menu .share.close .bar {
  top: 50%;
  margin-top: -1.5px;
  left: 50%;
  margin-left: -12px;
  -webkit-transform-origin: 50% 50%;
  -moz-transform-origin: 50% 50%;
  -ms-transform-origin: 50% 50%;
  -o-transform-origin: 50% 50%;
  transform-origin: 50% 50%;
  -webkit-transform: rotate(405deg);
  -moz-transform: rotate(405deg);
  -ms-transform: rotate(405deg);
  -o-transform: rotate(405deg);
  transform: rotate(405deg);
}

#ss_menu > .menu .share.close .bar:before {
  -webkit-transform-origin: 50% 50%;
  -moz-transform-origin: 50% 50%;
  -ms-transform-origin: 50% 50%;
  -o-transform-origin: 50% 50%;
  transform-origin: 50% 50%;
  -webkit-transform: rotate(-450deg);
  -moz-transform: rotate(-450deg);
  -ms-transform: rotate(-450deg);
  -o-transform: rotate(-450deg);
  transform: rotate(-450deg);
}

#ss_menu > .menu.ss_active {
  background: #415160;
  -webkit-transform: scale(0.7);
  -moz-transform: scale(0.7);
  -ms-transform: scale(0.7);
  -o-transform: scale(0.7);
  transform: scale(0.7);
}

#ss_menu > div {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  position: absolute;
  width: 60px;
  height: 60px;
  font-size: 10px;
  text-align: center;
  background: #415160;
  border-radius: 50%;
  display: table;
}

#ss_menu > div i {
  display: table-cell;
  vertical-align: middle;
}
#ss_menu > div a {
  color: #ffffff;
  text-decoration: none;
}
#ss_menu > div:hover {
  background: #2a2f34;
  cursor: pointer;
}

#ss_menu div:nth-child(1) {
  top: 0px;
  left: -160px;
}

#ss_menu div:nth-child(2) {
  top: -80px;
  left: -138.56406px;
}

#ss_menu div:nth-child(3) {
  top: -138.56406px;
  left: -80px;
}

#ss_menu div:nth-child(4) {
  top: -160px;
  left: 0px;
}

.carousel-3d-slide {
  background-color: #fff;
  cursor: pointer;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
}

.hspan,
.hspan2 {
  display: inline-block;
  position: relative;
  padding: 10px 20px;
  font-size: 30px;
  font-weight: 600;
}

.pzglImg {
  position: relative; /* 父容器设为相对定位 */
  width: 100%;
  height: 30vw; /* 按需设置高度 */
  overflow: hidden; /* 防止图片溢出 */
  margin: 15px 0;
  border: 1px solid #000;
  text-align: center;
  background-color: #fff;
}

.cpbzImg {
  position: relative; /* 父容器设为相对定位 */
  width: 100%;
  height: 18vw; /* 按需设置高度 */
  overflow: hidden; /* 防止图片溢出 */
  margin: 0;
  border: 1px solid #000;
  text-align: center;
  background-color: #fff;
}

.cpp {
  margin: 20px 0;
  text-align: center;
  font-size: 18px;
}

.container-fluid {
  margin: 70px auto;
}

.rzTop {
  margin: 90px 0;
  text-align: center;
}
.aqTop {
  margin: 0 0 90px 0;
  text-align: center;
}
.rzTop h1,
.aqTop h1 {
  margin: 50px 0;
}
.rzTop h1 span,
.aqTop h1 span {
  padding-bottom: 0;
  font-size: 34px;
  font-weight: 800;
}
.rzTop .rzp,
.aqTop .aqp {
  margin: 0 auto;
  width: 85vw;
  text-align: left;
  font-size: 20px;
  line-height: 40px;
}
.zzzsHeight {
  height: 70px;
}
.sjzxHeight {
  height: 70px;
}
.jtzlHeight {
  height: 70px;
}
.hover-content h1 {
  font-size: 18px;
  margin-top: 20px;
  margin-bottom: 10px;
}
.gradient-background {
  padding: 0 85px 100px;
  border-top: 1px solid #000;
  width: 100%;
  height: 100%; /* 設置高度為視口高度 */
  background: linear-gradient(
    to right,
    #ccc 0%,
    /* 左邊灰色 */ #ccc 5%,
    /* 灰色延伸到 25% */ #fff 20%,
    #fff 80%,
    /* 中間白色 */ #ccc 95%,
    /* 灰色延伸到 75% */ #ccc 100% /* 右邊灰色 */
  );
}

.mailbg {
  background: linear-gradient(
    to right,
    #ccc 0%,
    /* 左邊灰色 */ #ccc 5%,
    /* 灰色延伸到 25% */ #fff 20%,
    #fff 80%,
    /* 中間白色 */ #ccc 95%,
    /* 灰色延伸到 75% */ #ccc 100% /* 右邊灰色 */
  );
}

.cpTop {
  margin: 90px 0 0 0;
  text-align: center;
}
.cpTop h1 {
  margin: 50px 0 0 0;
}
.cpTop h1 span {
  padding-bottom: 0px;
  font-size: 34px;
  font-weight: 800;
}

.jtzlImg {
  border: 1px solid #000;
  text-align: center;
  background-color: #fff;
}

div /deep/ .jtzlImg img {
  padding: 5px;
  width: 100%;
  overflow: hidden;
  height: 10vw;
  border: 0;
}
/* 榮譽圖片註釋設置 */
.slideImg {
  width: 100%;
  height: 450px;
  margin-bottom: -30px;
  padding-bottom: 30px;
}
.slideh2 {
  text-align: center;
  font-size: 30px;
  margin-top: 20px;
  margin-bottom: 10px;
}
.slideP {
  padding-top: 10px;
  font-size: 16px;
  line-height: 30px;
}
#cpzl,
#cpbz,
#aqzc {
  border-top: 1px solid #000;
}

.aqImg {
  width: 85vw;
}

.carousel-3d-slide {
  background-color: #fff;
  cursor: pointer;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
}

@media screen and (max-width: 1400px) {
  .onlyPC {
    display: inline;
  }
  .container {
    padding: 0;
  }
  .button {
    margin: 10px 0;
    padding: 2px;
    font-size: 2em;
  }
  .hspan {
    font-size: 22px;
  }
  .slideImg {
    height: 170px;
  }
  .slideP {
    padding-top: 5px;
    font-size: 16px;
    line-height: 22px;
  }

  .xnytitle {
    font-size: 32px;
  }
  .xnyContent {
    font-size: 15px;
    margin: 0;
  }
  .rzTop h1 span,
  .cpTop h1 span {
    font-size: 25px;
  }
  .gradient-background {
    padding: 0 0 30px 0;
    background: white;
  }
  .mailbg {
    background: white;
  }

  .rzTop {
    margin: 15px 0;
  }
  .cpTop {
    margin: 0;
  }
  .rzTop h1,
  .cpTop h1 {
    margin: 30px 0;
  }
  .rzTop .rzp {
    margin: 0 auto;
    width: 85vw;
    text-align: left;
    font-size: 19px;
    font-weight: 500;
    line-height: 20px;
  }
  .col-xs-6,
  .col-xs-4 {
    padding: 0 10px;
  }

  .cpbzImg {
    height: 28vw;
  }
  .cpp {
    font-size: 18px;
    margin: 10px 0;
  }
  .container-fluid {
    margin: 15px 0;
  }
  .slideh2 {
    font-size: 24px;
  }
  .pzglImg {
    height: 45vw;
    margin: 10px 0;
  }
  .banner-info span {
    font-size: 30px;
  }
  .cbp-spmenu-push .banner {
    height: 350px;
  }
  .aqImg {
    width: 90vw;
  }
}
@media screen and (max-width: 768px) {
  .onlyPC {
    display: inline;
  }
  .container {
    padding: 0;
  }
  .button {
    margin: 10px 0;
    padding: 2px;
    font-size: 2em;
  }
  .hspan {
    font-size: 22px;
  }
  .slideImg {
    height: 170px;
  }
  .slideP {
    padding-top: 5px;
    font-size: 13px;
    line-height: 20px;
  }
  .xnytitle {
    font-size: 32px;
  }
  .xnyContent {
    font-size: 15px;
    margin: 0;
  }
  .rzTop h1 span,
  .cpTop h1 span {
    font-size: 20px;
  }
  .gradient-background {
    padding: 0 0 30px 0;
    background: white;
  }
  .mailbg {
    background: white;
  }
  .rzTop {
    margin: 15px 0;
  }
  .cpTop {
    margin: 0;
  }
  .rzTop h1,
  .cpTop h1 {
    margin: 30px 0;
  }
  .rzTop .rzp {
    margin: 0 auto;
    width: 85vw;
    text-align: left;
    font-size: 13px;
    font-weight: 500;
    line-height: 20px;
  }
  .col-xs-6,
  .col-xs-4 {
    padding: 0 5px;
  }

  .cpbzImg {
    height: 28vw;
  }
  .cpp {
    font-size: 13px;
    margin: 10px 0;
  }
  .container-fluid {
    margin: 10px 0;
  }
  .slideh2 {
    font-size: 20px;
  }
  .pzglImg {
    height: 50vw;
    margin: 5px 0;
  }
  .banner-info {
    width: 90vw;
  }
  .banner-info span {
    font-size: 26px;
  }
  .cbp-spmenu-push .banner {
    height: 200px;
  }
  .aqImg {
    width: 90vw;
  }
}
@media screen and (min-width: 2000px) {
  .banner-info span {
    font-size: 65px;
  }
  .rzTop h1 span,
  .cpTop h1 span {
    font-size: 40px;
  }
  .rzTop .rzp {
    font-size: 29px;
    line-height: 1.5;
  }
  .slideh2 {
    font-size: 35px;
    margin: 50px 0 30px 0;
  }
  .slideP {
    font-size: 26px;
    line-height: 1.5;
  }
  .cpp {
    font-size: 26px;
  }
}
</style>
